module.exports = {
	'support.m5.m510010.wf110': {
		'theSamePersonIsTransferredTo': 'Same person shifts on the same day.',
		'theSamePersonTunesDifferentDays': 'Same person shifts on different days.',
		'transferShiftsWithOthers': 'Swap shifts with others.',
		'supportForScheduling': 'Support with scheduling shifts.',
		'theSamePersonCanBeTransferred': 'Add/Delete/Edit shift information.',
		'theSamePersonCanBeTransferred2': 'Only allowed to swap shift information.',
		'shiftWithAnotherPersonCanOnly': 'Only allowed to swap shift information.',
		'supportSchedulingCrossOrganizationSupportFor': 'Support for cross-department scheduling.',
		'timeCheckErrors': 'Working hours error detected:',
		'originalShift': 'Original shift',
		'theDateShifts': 'The date you want to swap shifts',
		'shiftBtn1': 'Shift 1',
		'shiftBtn2': 'Shift 2',
		'recalculate': 'Recalculate',
		'scheduledShifts': 'Scheduled shifts',
		'supportShift': 'Support Shift',
		'viewShiftSchedule': 'Shift schedule',
	},
	'support.errorByDateCheck': {
		'A14': `The rescheduled employee is not on duty on the rescheduled date.`,
		'B14': `The swapped employee is not on duty on the rescheduled date.`,
		'A31': 'Errors detected: The number of shifts scheduled for that day has exceeded the daily maximum allowable shifts.',
		'B31': 'Errors detected: The number of shifts scheduled for that day has exceeded the daily maximum allowable shifts.',
		'A32': 'Errors detected: The shift change deadline has passed.',
		'B32': 'Errors detected: The shift change deadline has passed.',
		'A33': 'Errors detected: Only the "Rotating shifts (by shift)" or "Rotating shifts (by period)" can be modified.',
		'B33': 'Errors detected: Only the "Rotating shifts (by shift)" or "Rotating shifts (by period)" can be modified.',
		'A34': 'Errors detected: Only the shifts with the same attributes can be modified.',
		'B34': 'Errors detected: Only the shifts with the same attributes can be modified.',
		'A35': 'Errors detected: The working hours for the selected date have been settled.',
		'B35': 'Errors detected: The working hours for the selected date have been settled.',
		'A36': 'Errors detected: There is already a pending approval form for the same date.',
		'B36': 'Errors detected: There is already a pending approval form for the same date.',
	},
	'support.errorByTransferCheck': {
		'A11': `The staff being rescheduled and the person being swapped must be the same.`,
		'A12': `The rescheduled date and the swapped date must be the same.`,
		'A13': `The rescheduled employee does not exist in the company.`,
		'B13': `The swapped employee does not exist in the company.`,
		'A14': `The rescheduled employee is not on duty on the rescheduled date.`,
		'B14': `The swapped employee is not on duty on the rescheduled date.`,
		'A15': `The rescheduled date and the swapped date must not be the same.`,
		'A16': `The rescheduled employee and the swapped employee must not be the same person.`,
		'A17': `The rescheduled employee's calendar type, shift, and label after rescheduling must not be the same as the current status.`,
		'B17': `The swapped employee's calendar type, shift, and label after rescheduling must not be the same as the current status.`,
		// 'A18': `The rescheduled employee's calendar type, shift, and label before rescheduling must be the same as the current status.`,
		// 'B18': `The swapped employee's calendar type, shift, and label before rescheduling must be the same as the current status.`,
		'A18': `<%=A%>'s data was modified on <%=B%>.`,
		'B18': `<%=A%>'s data was modified on <%=B%>.`,
		'A19': `The cost center supporting the scheduling cannot be empty.`,
		'A20': 'The calendar dates of the rescheduled date and the swapped date are different.',
		'A23': `The total percentage of the cost centers supporting the scheduling must equal 100%.`,
		'A24': `The cost center ID supporting the scheduling does not exist in the company.`,
		'A25': `The reschedule ID does not exist in the company.`,
		'A26': `The form does not exist in the company.`,
		'A27': `The shift ID for the rescheduled employee does not exist in the company.`,
		'B27': `The shift ID for the swapped employee does not exist in the company.`,
		'A28': `The label ID for the rescheduled employee does not exist in the company.`,
		'B28': `The label ID for the swapped employee does not exist in the company.`,
		'A31': `The number of shifts scheduled for the rescheduled employee cannot exceed the daily available shift quota.`,
		'B31': `The number of shifts scheduled for the swapped employee cannot exceed the daily available shift quota.`,
		'A32': `The shift change deadline for the rescheduled employee has passed.`,
		'B32': `The shift change deadline for the swapped employee has passed.`,
		'A33': `Only the "Rotating shifts (by shift)" or "Rotating shifts (by period)" can be modified for the rescheduled employee.`,
		'B33': `Only the "Rotating shifts (by shift)" or "Rotating shifts (by period)" can be modified for the swapped employee.`,
		// 'A34': `Only the shifts with the same attributes can be modified for the rescheduled employee.`,
		// 'B34': `Only the shifts with the same attributes can be modified for the swapped employee.`,
		'A34': `<%=A%>'s shift attribute was changed on <%=B%>.`,
		'B34': `<%=A%>'s shift attribute was changed on <%=B%>.`,
		'A35': `The working hours for the selected date have been settled for the rescheduled employee.`,
		'B35': `The working hours for the selected date have been settled for the swapped employee.`,
		'A36': `There is already a pending approval form for the same date for the rescheduled employee.`,
		'B36': `There is already a pending approval form for the same date for the swapped employee.`,
		'A37': `Such request type is unopened.`,
		'A38': `The items available for modification are not enabled.`,
		// 'A39': `The rescheduled employee's working hours on the rescheduled date overlap.`,
		// 'B39': `The swapped employee's working hours on the rescheduled date overlap.`,
		'A39': `<%=A%>'s <%=C%> and <%=E%> working hours overlap on <%=B%>.`,
		'B39': `<%=A%>'s <%=C%> and <%=E%> working hours overlap on <%=B%>.`,
		'A40': `The date for the rescheduled employee does not comply with working hours regulations (Reminder).`,
		'B40': `The date for the swapped employee does not comply with working hours regulations (Reminder).`,
		'A41': `The date for the rescheduled employee does not comply with working hours regulations (Prohibition).`,
		'B41': `The date for the swapped employee does not comply with working hours regulations (Prohibition).`,
		// 'A42': `The rescheduled employee's rescheduled date exceeds the shift rescheduling limit.`,
		// 'B42': `The swapped employee's rescheduled date exceeds the shift rescheduling limit.`,
		'A42': `<%=A%> has reached the limit for shift adjustments from <%=B%> to <%=C%>.`,
		'B42': `<%=A%> has reached the limit for shift adjustments from <%=B%> to <%=C%>.`,
	},
	'support.errorByTransferResend': {
		'A14': `The rescheduled employee is not on duty on the rescheduled date.`,
		'B14': `The swapped employee is not on duty on the rescheduled date.`,
		'A31': 'The number of shifts scheduled for that day has exceeded the daily maximum allowable shifts.',
		'B31': 'The number of shifts scheduled for that day has exceeded the daily maximum allowable shifts.',
		'A32': 'The deadline for schedule changes has passed.',
		'B32': 'The deadline for schedule changes has passed.',
		'A33': 'Only the "Rotating shifts (by shift)" or "Rotating shifts (by period)" can be modified.',
		'B33': 'Only the "Rotating shifts (by shift)" or "Rotating shifts (by period)" can be modified.',
		'A34': 'The shift attributes have been modified.',
		'B34': 'The shift attributes have been modified.',
		'A35': 'The working hours for the shift have been settled.',
		'B35': 'The working hours for the shift have been settled.',
		'A36': 'There is already a pending approval form for the same date.',
		'B36': 'There is already a pending approval form for the same date.',
		'A37': 'Such request type is unopened.',
		'B37': 'Such request type is unopened.',
		'notInChangeableEmpIds': 'No longer eligible for the applicable changes.',
	},
	'support.errorByInsertShift': {
		'11': 'The working hours is required.',
		'12': 'Working hours overlap.',
		'13': 'Rest time overlaps with the working hours of multiple shifts.',
		'14': 'Rest time overlaps.',
		'15': 'The end time of the working hours is earlier than the start time.',
		'16': 'The end time of the rest period is earlier than the start time.',
		'17': 'There is an error in the calendar data.',
		'18': 'The working hours end time cannot be the same as the start time.',
		'19': 'The rest period end time cannot be the same as the start time.',
	},
	'support.m5.m510010.wf110_common': {
		'areYouSureYouWantTo': 'Are you sure you want to restore the default settings?',
		'restoreDefaultValues': 'Restore',
	},
	'support.service.m5.service-m510010_wf110': {
		'theDataHasBeenChangedBefore': `<%=temp1%>'s data was modified on <%=temp2%>.`,
		'calendarIsRequired': 'Calendar is required.',
		'noSpecificWorkingHoursSet': 'No specific working hours set.',
		'reasonIsRequired': 'Reason is required.',
		'attachmentIsRequired': 'Attachment is required.',
	},
	'support.m5.m510010.wf110_rows': {
		'adjusted': 'Adjusted',
		'checkOutTheSchedule': 'Shift schedule',
		'leaveInformation': 'Leave Info.',
		'overtimeInformation': 'Overtime Info.',
		'leaveStr': 'Leave: <%=n%> <%=unit%><%=s%>',
		'leaveCancelStr': 'Leave resumption: <%=n%> <%=unit%><%=s%>',
		'overtimeStr': 'Overtime: <%=n%> <%=unit%><%=s%>',
	},
	'support.m5.preview.wf110': {
		'shiftAfterShift': 'Shift after the adjustment',
		'thePeriodAfterTheShift': 'Working hours after shift adjustment',
	},
	'support.m5.details.wf110': {
		'breakTimeAfterShifting': 'Rest hours after shift adjustment',
		'aTotalOfShifts': '<%=temp1%> shift<%=s%> adjustment in total.',
		'aTotalOfTransactionsAreSupported': '<%=temp1%> support for shift<%=s%> in total.',
		'aTotalOfScheduledShift': '<%=temp1%> scheduled shift<%=s%> in total.',
	},
	'support.m5.m510010.wf110.download': {
		'shiftPersonnel': 'Shift adjustment personnel',
		'scheduledWorkingHours': 'Scheduled working hours for the day',
		'workingHours': 'Working hours',
		'restTime': 'Rest time',
		'costCenter': '(Cost center:<%=temp%>)',
	},
	'support.sp_sa_emp_transfer_CheckDelete': {
		'11': 'The shift adjustment data does not exist in the company.',
		'12': 'The status of the form must be "In Progress" to be deleted.',
	},
	'support.m5.m510010.wf110_support': {
		'scheduledBreaks': 'Scheduled rest time',
	},
};
